import {
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CSSObject } from "types/types";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgb(125, 217, 255)",
    color: "rgb(59, 59, 59)",
    fontWeight: "bold",
    border: "2px solid rgb(234, 234, 234)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    border: "2px solid rgb(234, 234, 234)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

const tableContainerStyles: CSSObject = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "800px",
    "@media print": {
      breakInside: "avoid",
      pageBreakBefore: "avoid",
      pageBreakAfter: "always",
    },
  },
};

export interface IStudentUsageData {
  gradeId: number;
  gradeCode: string;
  totalStudents: number;
  studentsWithSomeCompletion: number;
  activeStudents: number;
}

interface IStudentUsageProps {
  data: IStudentUsageData[];
}

const StudentUsage = ({ data }: IStudentUsageProps) => {
  const { t } = useTranslation();
  const HEADER_DATA = [
    t("Grade"),
    t("Total Students"),
    t("Active Students"),
    t("Engaged Students"),
  ];
  return (
    <TableContainer sx={tableContainerStyles.root}>
      <Table sx={{ minWidth: 700 }} aria-label="Assignment Data">
        <TableHead>
          <TableRow>
            {HEADER_DATA.map((header, index) => (
              <StyledTableCell align="center" key={"header-" + index}>
                {t(header)}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((grade) => (
            <StyledTableRow key={`row-${grade.gradeId}`}>
              {[
                grade.gradeCode,
                grade.totalStudents,
                grade.activeStudents,
                grade.studentsWithSomeCompletion,
              ].map((value, cellIndex) => (
                <StyledTableCell
                  align="center"
                  key={`cell-${grade.gradeId}-${cellIndex}`}
                >
                  {cellIndex === 0 ? t(value as string) : value}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StudentUsage;
